import { env } from "@/env.mjs";
import { ofetch } from "ofetch";

export const fetchRawCentraCountry = async () => {
	try {
		const data = await ofetch<{
			location?: { country: string };
			countries?: { country: string }[];
		}>(`${env.NEXT_PUBLIC_CENTRA_CHECKOUT}/selection`);

		const centraCountry = data.location?.country;
		const countries = data.countries;

		if (!centraCountry) {
			throw new Error("Failed to fetch country");
		}

		return { centraCountry, countries: countries ?? [] };
	} catch (error) {
		console.error(`[fetchRawCentraCountry]: ${error}`);
	}
};
